'use client';

import { useState } from 'react';
import { MuiColorInput } from 'mui-color-input';

const ColorPicker = ({ value, onChange, label = 'Choose Color' }) => {
  const [showPicker, setShowPicker] = useState(false);

  const presetColors = [
    '#007bff', // Bootstrap Primary
    '#6c757d', // Bootstrap Secondary
    '#28a745', // Bootstrap Success
    '#dc3545', // Bootstrap Danger
    '#ffc107', // Bootstrap Warning
    '#17a2b8', // Bootstrap Info
    '#343a40', // Bootstrap Dark
    '#f8f9fa', // Bootstrap Light
    '#6f42c1', // Purple
    '#e83e8c', // Pink
    '#fd7e14', // Orange
    '#20c997', // Teal
  ];

  return (
    <div className="mb-3">
      <label className="form-label fw-bold">
        <i className="fas fa-palette me-2"></i>
        {label}
      </label>

      <div className="d-flex align-items-center gap-3">
        {/* Color Preview */}
        {/* <div
          className="color-preview-large rounded border"
          style={{
            width: "50px",
            height: "40px",
            backgroundColor: value,
            cursor: "pointer",
            border: "2px solid #dee2e6",
          }}
          onClick={() => setShowPicker(!showPicker)}
          title="Click to open color picker"
        ></div> */}

        {/* Color Input */}
        <div className="flex-grow-1">
          <MuiColorInput
            className="form-control form-control-color"
            format="hex"
            value={value}
            onChange={newHex => onChange(newHex?.toUpperCase?.())}
            fallbackValue="#000000"
            // size="small"
            isAlphaHidden={true} // This disables the alpha slider
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '0px !important',
                height: 53,
              },
              '& .MuiOutlinedInput-input': {
                height: '36px',
              },
              '& .MuiColorInput-Button': {
                width: '49px !important', // Increase width
                height: '40px !important',
              },
              '& .MuiInputAdornment-root .MuiBox-root': {
                width: 18,
                height: 18,
              },
            }}
          />
          {/* <input
            type="color"
            className="form-control form-control-color"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            style={{ width: "60px", height: "40px" }}
          /> */}
        </div>

        {/* Hex Input */}
        <div style={{ width: '100px' }}>
          <input
            type="text"
            className="form-control text-center"
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder="#000000"
            pattern="^#[0-9A-Fa-f]{6}$"
          />
        </div>
      </div>

      {/* Preset Colors */}
      <div className="mt-3">
        <small className="text-muted mb-2 d-block">Quick Colors:</small>
        <div className="d-flex flex-wrap gap-2">
          {presetColors.map(color => (
            <div
              key={color}
              className="preset-color rounded border"
              style={{
                width: '30px',
                height: '30px',
                backgroundColor: color,
                cursor: 'pointer',
                border: value === color ? '3px solid #000' : '2px solid #dee2e6',
              }}
              onClick={() => onChange(color)}
              title={color}
            ></div>
          ))}
        </div>
      </div>

      {/* Color Info */}
      <div className="mt-2">
        <small className="text-muted">
          Current color: <strong>{value}</strong>
        </small>
      </div>
    </div>
  );
};

export default ColorPicker;
